import { render, staticRenderFns } from "./InquiryPage.vue?vue&type=template&id=670b2ded&scoped=true"
import script from "./InquiryPage.vue?vue&type=script&lang=js"
export * from "./InquiryPage.vue?vue&type=script&lang=js"
import style0 from "./InquiryPage.vue?vue&type=style&index=0&id=670b2ded&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670b2ded",
  null
  
)

export default component.exports